if (!window.SummerCampaign) {
  window.SummerCampaign = {};

  function createVideoEmbed(url) {
    var embedUrl = '';

    try {
      var parsedUrl = new URL(url, window.location.origin);
      var hostname = parsedUrl.hostname.replace('www.', '');

      if (hostname === 'youtu.be') {
        embedUrl = 'https://www.youtube.com/embed/' + parsedUrl.pathname.replace('/', '');
      } else if (hostname.indexOf('youtube.com') !== -1) {
        embedUrl = 'https://www.youtube.com/embed/' + parsedUrl.searchParams.get('v');
      } else if (hostname.indexOf('vimeo.com') !== -1) {
        embedUrl = 'https://player.vimeo.com/video/' + parsedUrl.pathname.split('/').filter(Boolean).pop();
      }
    } catch (error) {
      return null;
    }

    if (!embedUrl || embedUrl.slice(-4) === 'null') {
      return null;
    }

    var iframe = document.createElement('iframe');
    iframe.src = embedUrl + '?autoplay=1';
    iframe.title = 'Campaign video';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    return iframe;
  }

  function initSummerCampaign(root) {
    if (!root || root.dataset.summerBound === 'true') {
      return;
    }

    root.dataset.summerBound = 'true';

    root.querySelectorAll('[data-summer-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var answer = document.getElementById(trigger.getAttribute('aria-controls'));
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        trigger.setAttribute('aria-expanded', String(!expanded));
        if (answer) {
          answer.hidden = expanded;
        }
      });
    });

    var modal = root.querySelector('[data-summer-video-modal]');
    var frame = root.querySelector('[data-summer-video-frame]');
    var lastVideoTrigger = null;

    function closeModal() {
      if (!modal || !frame) {
        return;
      }

      modal.hidden = true;
      frame.replaceChildren();
      document.documentElement.style.removeProperty('overflow');

      if (lastVideoTrigger) {
        lastVideoTrigger.focus();
      }
    }

    root.querySelectorAll('[data-summer-video-url]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var iframe = createVideoEmbed(trigger.dataset.summerVideoUrl);

        if (!modal || !frame || !iframe) {
          return;
        }

        lastVideoTrigger = trigger;
        frame.replaceChildren(iframe);
        modal.hidden = false;
        document.documentElement.style.setProperty('overflow', 'hidden');

        var closeButton = modal.querySelector('.summer-video-modal__close');
        if (closeButton) {
          closeButton.focus();
        }
      });
    });

    root.querySelectorAll('[data-summer-video-link]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        window.location.href = trigger.dataset.summerVideoLink;
      });
    });

    if (modal) {
      modal.querySelectorAll('[data-summer-video-close]').forEach(function (trigger) {
        trigger.addEventListener('click', closeModal);
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initAllSummerCampaignSections(container) {
    var scope = container || document;

    if (scope.matches && scope.matches('[data-summer-campaign]')) {
      initSummerCampaign(scope);
    }

    scope.querySelectorAll('[data-summer-campaign]').forEach(initSummerCampaign);
  }

  window.SummerCampaign.init = initAllSummerCampaignSections;

  document.addEventListener('DOMContentLoaded', function () {
    initAllSummerCampaignSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllSummerCampaignSections(event.target);
  });
}
